import { STORE_TYPES_NAMES, STORE_DETAILS_TAB_ICONS, STORE_TYPES } from './constants';

export const formatDistance = (distance = 0) => {
  return `${parseFloat(String(distance / 1000)).toFixed(2)}`;
};

export const getLocationName = (fullStoreName: string) => {
  const getStoreTypeIndex = STORE_TYPES_NAMES.findIndex((storeType) => fullStoreName.includes(storeType));
  const storeNameIndex = STORE_TYPES_NAMES[getStoreTypeIndex]?.length + 1;
  return fullStoreName.substring(storeNameIndex || 0);
};

export const getStoreName = (fullStoreName: string) => {
  const getStoreTypeIndex = STORE_TYPES_NAMES.findIndex((storeType) => fullStoreName.includes(storeType));
  const storeNameIndex = STORE_TYPES_NAMES[getStoreTypeIndex]?.length + 1;
  return fullStoreName.substring(0, storeNameIndex);
};

export const getInitialNavItems = (formatMessage: any, storeType: string, hasCareClinic: boolean) => {
  const { STORE_BLACK_URL, STORE_RED_URL, PHARMACY_BLACK_URL, PHARMACY_RED_URL, CLINIC_BLACK_URL, CLINIC_RED_URL } =
    STORE_DETAILS_TAB_ICONS;

  const storeTab = {
    icon: {
      url: STORE_BLACK_URL,
      altText: null,
    },
    displayText1: formatMessage({ id: 'store' }),
    url: '/',
    isActive: true,
    iconUrls: { default: STORE_BLACK_URL, activated: STORE_RED_URL },
  };
  const pharmacyServicesTab = {
    icon: {
      url: PHARMACY_BLACK_URL,
      altText: null,
    },
    displayText1: formatMessage({ id: 'pharmacyAndServices' }),
    url: '/pharmacy',
    isActive: false,
    iconUrls: { default: PHARMACY_BLACK_URL, activated: PHARMACY_RED_URL },
  };
  const pharmacyCareClinicTab = {
    icon: {
      url: CLINIC_BLACK_URL,
      altText: null,
    },
    displayText1: formatMessage({ id: 'pharmacyCareClinic' }),
    url: '/pharmacist-walk-in-clinic',
    isActive: false,
    iconUrls: { default: CLINIC_BLACK_URL, activated: CLINIC_RED_URL },
  };

  let storeDetailsTabs = [storeTab];
  if (storeType === STORE_TYPES.WW) {
    return storeDetailsTabs;
  } else {
    storeDetailsTabs = [storeTab, pharmacyServicesTab];
    if (hasCareClinic) storeDetailsTabs.push(pharmacyCareClinicTab);
  }
  return storeDetailsTabs;
};
